var splitscreen_args_mobile = {
  accessibility: true,
  arrows: false,
  dots: true,
  draggable: true,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: true,
};

document.addEventListener("DOMContentLoaded", function () {
    if ($(window).width() < 590 ) {
        $('.splitscreen-slick-container').slick(splitscreen_args_mobile);
    }
    else {
        $('.splitscreen-slick-container').slick(splitscreen_args_mobile);
    }
});